// Copyright (c) 2017 Deere & Company

import LaborRateApproval from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.laborRateApproval
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;
    const {tcsm} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams,
        tcsm
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborRateApproval);



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/state-connector.js